export default __webpack_public_path__ + "static/media/icon-contacts.da68072c.svg";